export const AGENTS = [
  {
    id: "discharge",
    name: "Discharge Summary Agent",
    tagline: "Clinician-verified · source-traced drafts",
    description:
      "Pulls admission notes, orders, vitals, and procedures into a structured discharge summary from IPD case sheets or scannable documents. Discharge Summary API is available for hospital integrations. Your clinician reviews, edits, and signs — nothing goes to the patient without approval.",
    inputs: [
      "IPD case sheet & direct IPD data",
      "Scannable documents (PDF / images)",
      "Orders & nursing notes",
      "Vitals trend",
      "Procedure list",
    ],
    outputs: [
      "Discharge summary draft",
      "ICD codes",
      "Insurance summary",
      "Revenue leakage flags",
      "Diet guide (patient-specific)",
      "Medication reconciliation",
      "Follow-up instructions",
    ],
    link: "/generate-ai-patient-summary",
    accent: true,
  },
  {
    id: "nutrition",
    name: "Nutritional Agent",
    tagline: "Diet plans grounded in clinical context",
    description:
      "Reads vitals, diagnosis, body composition, and patient habits to suggest structured diet plans — not generic templates. Dietitian or doctor reviews before sharing with the patient.",
    inputs: ["Vitals & labs", "Diagnosis & comorbidities", "Body composition (BCA)", "Food habits & lifestyle"],
    outputs: ["Personalized diet plan", "Macro breakdown", "Clinician review queue"],
    link: "/nutritional-agent",
    accent: true,
  },
  {
    id: "voice-receptionist",
    name: "Voice Receptionist Agent",
    tagline: "24/7 booking · 22 Indian languages",
    description:
      "Answers calls and website voice sessions — checks doctor availability, books and reschedules appointments, and captures intake. Deploy on your clinic website or share a QR code; patients talk naturally while slots sync to your EMR OPD queue.",
    inputs: [
      "Doctor schedule & live availability",
      "OPD slot inventory",
      "Clinic / hospital profile",
      "Patient phone & visit reason",
    ],
    outputs: [
      "Booked appointment in EMR",
      "Intake captured",
      "Slot confirmation",
      "Optional payment hold flow",
    ],
    link: "/voice-receptionist-agent",
    accent: true,
  },
  {
    id: "whatsapp-care",
    name: "WhatsApp Follow-up Agent",
    tagline: "e-Rx delivery · reminders · revisit nudges",
    description:
      "Sends e-prescriptions on WhatsApp after clinician sign-off, plus appointment reminders, medicine follow-ups, and review visit prompts — all from the patient chart with delivery status and audit log.",
    inputs: [
      "Signed e-prescription",
      "Appointment schedule",
      "Follow-up & medicine protocol",
      "Patient WhatsApp number",
    ],
    outputs: [
      "WhatsApp e-Rx to patient",
      "Appointment reminder",
      "Medicine adherence nudge",
      "Revisit booking prompt",
    ],
    link: "#integrations",
    accent: true,
  },
  {
    id: "summary",
    name: "Visit Summary Agent",
    tagline: "Instant context before every consult",
    description:
      "Summarizes prior visits, investigations, and active problems so doctors walk in prepared — without scrolling through years of records.",
    inputs: ["Visit history", "Prescriptions", "Lab reports", "Active complaints"],
    outputs: ["Visit summary card", "Trend highlights", "Open care gaps"],
    link: "#agents",
  },
  {
    id: "doc",
    name: "Doc Agent",
    tagline: "Structured clinical history from raw records",
    description:
      "Scans uploaded documents and chart data to extract allergies, surgeries, medications, and family history into structured EMR fields.",
    inputs: ["Uploaded PDFs & images", "Prior discharge summaries", "Referral letters"],
    outputs: ["Structured history", "Medication list", "Allergy flags"],
    link: "#agents",
  },
  {
    id: "deep",
    name: "Deep Healthcare Agent",
    tagline: "Patient-aware answers inside your workflow",
    description:
      "Ask questions on live patient data — schedule follow-ups, suggest physio protocols, or clarify diet constraints. Answers cite chart context; clinicians stay in control.",
    inputs: ["Live patient chart", "Care protocols", "Appointment calendar"],
    outputs: ["Contextual answers", "Follow-up suggestions", "Care coordination tasks"],
    link: "#agents",
    accent: true,
  },
  {
    id: "soap",
    name: "SOAP Agent",
    tagline: "22-language support · structured consult notes",
    description:
      "Turns consult notes and dictation into structured SOAP (Subjective, Objective, Assessment, Plan) in 22 languages. Draft stays in the chart for clinician review before it becomes the visit record.",
    inputs: ["Consult notes & dictation", "Chief complaint", "Exam findings", "Prior visit context"],
    outputs: ["SOAP note draft", "Assessment & plan", "Multilingual chart text"],
    link: "#agents",
    accent: true,
  },
];
